import { Dashboard } from "components";
import { Input } from "expano-components";

const getFilterLabel = (label) => {
  switch (label) {
    case "offerTitleContains":
      return "Tytuł oferty zawiera";
    case "priceFrom":
      return "Cena od";
    case "priceTo":
      return "Cena do";
    case "categoryId":
      return "ID kategorii";
    default:
      return label;
  }
};

const prepareFilters = (a) => {
  if (a?.filters?.length > 0) {
    return a.filters.map((filter) => {
      const key = Object.keys(filter)?.[0];

      return { label: getFilterLabel(key), value: filter?.[key] };
    });
  }

  return [];
};

const CampaignFilters = ({ channel_campaign_group }) => {
  const data = prepareFilters(channel_campaign_group.external_offers);

  return (
    <Dashboard
      header={{
        icon: "channel",
        title: "Filtry",
      }}
    >
      <div className="dashboard__form">
        {data?.map(({ label, value }, index) => (
          <Input
            key={index}
            label={label}
            disabled
            meta={{}}
            input={{
              name: "filter",
              value,
            }}
          />
        ))}
      </div>
    </Dashboard>
  );
};

export default CampaignFilters;
